class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    const animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      animations.forEach((animation) => animation.play());
    } else {
      animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
  }

  connectedCallback() {
    if (!this.mainDetailsToggle) return;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    if (this.header && !window.__headerScrollHandlerInitialized) {
      const updateHeaderTopState = () => {
        const atTop = window.scrollY === 0;
        this.header.classList.toggle('is-at-top', atTop);
      };

      updateHeaderTopState();
      window.addEventListener('scroll', updateHeaderTopState, { passive: true });

      window.__headerScrollHandlerInitialized = true;
    }
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onMouseEnter() {
    if (!this.isDesktop()) return;
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
      this.onToggle();
    }
  }

  onMouseLeave(event) {
    if (!this.isDesktop()) return;
    const toElement = event.relatedTarget;
    if (toElement && this.contains(toElement)) return;

    this.closeTimeout = setTimeout(() => {
      this.close();
      this.onToggle();
    }, 80);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Toggle header background state when any header menu is open
    const anyOpen = !!document.querySelector('header-menu details[open]');
    this.header.classList.toggle('header--menu-open', anyOpen);

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
